/**
 * MVP-353. Plain `.ts` so it is importable under `node --test` without a JSX loader — the same
 * reason every other pure decision in this directory (`clock.ts`, `connectionStatus.ts`,
 * `hotkeys.ts`, ...) lives next to, not inside, its component. Named `miniTransportVisibility.ts`
 * rather than `miniTransportBar.ts` (the task's own file name) — `tsc` refuses to build with both
 * that name and `MiniTransportBar.tsx` in the same directory, since the two differ only by the
 * first letter's case, which Windows/macOS's default case-insensitive filesystems cannot tell
 * apart.
 *

 * `title === null` is the bridge's own "nothing to show" state (`useTransportBridge.ts` — no
 * cockpit mounted yet, or the cockpit has no active song); `view === 'cockpit'` is the one screen
 * that already has the full transport controls on screen, where a second, smaller copy of the same
 * play/pause button would be redundant chrome rather than a convenience.
 */
export function shouldShowMiniTransport(title: string | null, view: string): boolean {
  return title !== null && view !== 'cockpit';
}
